// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"47a15482","605":"82ac6a47","809":"62452d41","981":"a501b838"}[chunkId] + ".chunk.js";
};